module.exports = {
    "religion": [
        "Hindu",
        "Muslim",
        "Christian",
        "Sikh",
        "Buddhist",
        "Jain",
        "Parsi",
        "Indigenous Faith",
        "Jews",
        "Other"
    ],
    "region": [
        "Rural",
        "Urban"
    ],
    "gender": [
        "Male",
        "Female",
        "Others"
    ],
    "motherTongue": [
        "Assamee",
        "Bengali",
        "Dogri",
        "English",
        "Gujar",
        "Gujarati",
        "Hindi",
        "Kannada",
        "Kashmiri",
        "Khasi",
        "Konkani",
        "Malayalam",
        "Manipuri",
        "Marathi",
        "Mizo",
        "Oriya",
        "Punjabi",
        "Sanskrit",
        "Sindhi",
        "Tamil",
        "Telugu",
        "Urdu",
        "Other"
    ],
    "familyIncome": [
        "0 - 15,000",
        "15,001 - 50,000",
        "50,001 - 1,00,000",
        "1,00,001 - 1,50,000",
        "1,50,001 - 2,00,000",
        "2,00,001 -2,50,000",
        "2,50,001 - 3,00,000",
        "3,00,001 - 3,50,000",
        "3,50,001 - 4,00,000",
        "4,00,001 - 4,50,000",
        "4,50,001 - 5,00,000",
        "5,00,001 - 5,50,000",
        "5,50,001 - 6,00,000",
        "6,00,001 - 7,00,000",
        "7,00,001 - 8,00,000",
        "8,00,001 - 9,00,000",
        "9,00,001 - 10,00,000",
        "10,00,001 - 15,00,000",
        ">= 15,00,001"
    ],
    "maritalStatus": [
        "Married",
        "UnMarried"
    ],
    "linguisticMinority": [
        "Gujarathi",
        "Gujarathi (Kutchhi)",
        "Gujarathi (Jain)",
        "Hindi",
        "Hindi (Bhojpuri)",
        "Kannada",
        "Malyalam",
        "Punjabi",
        "Sindhi",
        "Tamil",
        "Urdu",
        "Gujar",
        "NA"
    ],
    "religiousMinority": [
        "Buddhist",
        "Christian",
        "Jain",
        "Muslim",
        "Christian (Roman Catholics)",
        "Sikh",
        "Parsi",
        "Zorostrian",
        "NA"
    ],
    "boolStatus": [
        "Yes",
        "No"
    ],
    "pwdType": [
        "Leprosy Cured Person",
        "Cerebral Palsy",
        "Dwarfism",
        "Muscular Dystrophy",
        "Acid Attack Victims",
        "Blindness",
        "Low Vision",
        "Deaf",
        "Hard of Hearing",
        "Dyslexia",
        "Dysgraphia",
        "Dyscalculia",
        "Dyspraxia",
        "Developmental Aphasia",
        "Autism Spectrum Disorder",
        "Mental Illness",
        "Multiple Sclerosis",
        "Parkinsons Disease",
        "Haemophilia",
        "Thalassemia",
        "Sickle Cell Disease",
        "Speech and Language Disability",
        "Locomotor disability (Including specified disabilities)"
    ],
    "marksType": [
        "Percentage",
        "CGPA"
    ],
    "nationality": [
        {
            "id": 1,
            "name": "Afghan"
        },
        {
            "id": 2,
            "name": "Albanian"
        },
        {
            "id": 3,
            "name": "Algerian"
        },
        {
            "id": 222,
            "name": "American"
        },
        {
            "id": 5,
            "name": "Andorran"
        },
        {
            "id": 6,
            "name": "Angolan"
        },
        {
            "id": 9,
            "name": "Argentinian"
        },
        {
            "id": 10,
            "name": "Armenian"
        },
        {
            "id": 11,
            "name": "Aruba-Dutch"
        },
        {
            "id": 12,
            "name": "Australian"
        },
        {
            "id": 13,
            "name": "Austrian"
        },
        {
            "id": 14,
            "name": "Azerbaijani"
        },
        {
            "id": 15,
            "name": "Bahamian"
        },
        {
            "id": 16,
            "name": "Bahraini"
        },
        {
            "id": 17,
            "name": "Bangladeshi"
        },
        {
            "id": 18,
            "name": "Barbadian"
        },
        {
            "id": 19,
            "name": "Belarusian"
        },
        {
            "id": 20,
            "name": "Belgian"
        },
        {
            "id": 21,
            "name": "Belizean"
        },
        {
            "id": 22,
            "name": "Beninese"
        },
        {
            "id": 23,
            "name": "Bermudian"
        },
        {
            "id": 24,
            "name": "Bhutanese"
        },
        {
            "id": 25,
            "name": "Bolivian"
        },
        {
            "id": 26,
            "name": "Bosnian"
        },
        {
            "id": 27,
            "name": "Botswanan"
        },
        {
            "id": 28,
            "name": "Brazilian"
        },
        {
            "id": 221,
            "name": "British"
        },
        {
            "id": 31,
            "name": "Bulgarian"
        },
        {
            "id": 32,
            "name": "Burkinese"
        },
        {
            "id": 143,
            "name": "Burmese"
        },
        {
            "id": 33,
            "name": "Burundian"
        },
        {
            "id": 36,
            "name": "Cambodian"
        },
        {
            "id": 37,
            "name": "Cameroonian"
        },
        {
            "id": 38,
            "name": "Canadian"
        },
        {
            "id": 42,
            "name": "Chadian"
        },
        {
            "id": 44,
            "name": "Chilean"
        },
        {
            "id": 45,
            "name": "Chinese"
        },
        {
            "id": 46,
            "name": "Colombian"
        },
        {
            "id": 48,
            "name": "Congolese"
        },
        {
            "id": 50,
            "name": "Costa Rican"
        },
        {
            "id": 51,
            "name": "Croat"
        },
        {
            "id": 52,
            "name": "Cuban"
        },
        {
            "id": 54,
            "name": "Cypriot"
        },
        {
            "id": 55,
            "name": "Czech"
        },
        {
            "id": 57,
            "name": "Danish"
        },
        {
            "id": 58,
            "name": "Djiboutian"
        },
        {
            "id": 60,
            "name": "Dominican"
        },
        {
            "id": 59,
            "name": "Dominican"
        },
        {
            "id": 147,
            "name": "Dutch"
        },
        {
            "id": 61,
            "name": "Ecuadorean"
        },
        {
            "id": 62,
            "name": "Egyptian"
        },
        {
            "id": 220,
            "name": "Emirati"
        },
        {
            "id": 65,
            "name": "Eritrean"
        },
        {
            "id": 66,
            "name": "Estonian"
        },
        {
            "id": 67,
            "name": "Ethiopian"
        },
        {
            "id": 70,
            "name": "Fijian"
        },
        {
            "id": 71,
            "name": "Finnish"
        },
        {
            "id": 72,
            "name": "French"
        },
        {
            "id": 75,
            "name": "Gabonese"
        },
        {
            "id": 76,
            "name": "Gambian"
        },
        {
            "id": 77,
            "name": "Georgian"
        },
        {
            "id": 78,
            "name": "German"
        },
        {
            "id": 79,
            "name": "Ghanaian"
        },
        {
            "id": 80,
            "name": "Gibraltarian"
        },
        {
            "id": 109,
            "name": "Gilbertese"
        },
        {
            "id": 81,
            "name": "Greek"
        },
        {
            "id": 82,
            "name": "Greenlandic"
        },
        {
            "id": 83,
            "name": "Grenadian"
        },
        {
            "id": 85,
            "name": "Guamanian"
        },
        {
            "id": 86,
            "name": "Guatemalan"
        },
        {
            "id": 162,
            "name": "Guinean"
        },
        {
            "id": 87,
            "name": "Guinean"
        },
        {
            "id": 89,
            "name": "Guyanese"
        },
        {
            "id": 90,
            "name": "Haitian"
        },
        {
            "id": 92,
            "name": "Honduran"
        },
        {
            "id": 93,
            "name": "Hong Kongese"
        },
        {
            "id": 94,
            "name": "Hungarian"
        },
        {
            "id": 95,
            "name": "Icelandic"
        },
        {
            "id": 96,
            "name": "Indian"
        },
        {
            "id": 97,
            "name": "Indonesian"
        },
        {
            "id": 98,
            "name": "Iranian"
        },
        {
            "id": 99,
            "name": "Iraqi"
        },
        {
            "id": 100,
            "name": "Ireland"
        },
        {
            "id": 102,
            "name": "Israeli"
        },
        {
            "id": 103,
            "name": "Italian"
        },
        {
            "id": 104,
            "name": "Jamaican"
        },
        {
            "id": 105,
            "name": "Japanese"
        },
        {
            "id": 106,
            "name": "Jordanian"
        },
        {
            "id": 107,
            "name": "Kazakh"
        },
        {
            "id": 108,
            "name": "Kenyan"
        },
        {
            "id": 110,
            "name": "Kuwaiti"
        },
        {
            "id": 111,
            "name": "Kyrgyz"
        },
        {
            "id": 112,
            "name": "Lao Laotian"
        },
        {
            "id": 113,
            "name": "Latvian"
        },
        {
            "id": 114,
            "name": "Lebanese"
        },
        {
            "id": 116,
            "name": "Liberian"
        },
        {
            "id": 117,
            "name": "Libyan"
        },
        {
            "id": 118,
            "name": "Liechtenstein"
        },
        {
            "id": 119,
            "name": "Lithuanian"
        },
        {
            "id": 120,
            "name": "Luxembourg"
        },
        {
            "id": 121,
            "name": "Macanese"
        },
        {
            "id": 122,
            "name": "Macedonian"
        },
        {
            "id": 123,
            "name": "Madagascan"
        },
        {
            "id": 124,
            "name": "Malawian"
        },
        {
            "id": 125,
            "name": "Malaysian"
        },
        {
            "id": 126,
            "name": "Maldivian"
        },
        {
            "id": 127,
            "name": "Malian"
        },
        {
            "id": 128,
            "name": "Maltese"
        },
        {
            "id": 130,
            "name": "Martinican"
        },
        {
            "id": 131,
            "name": "Mauritanian"
        },
        {
            "id": 132,
            "name": "Mauritian"
        },
        {
            "id": 134,
            "name": "Mexican"
        },
        {
            "id": 135,
            "name": "Micronesian"
        },
        {
            "id": 136,
            "name": "Moldova (Romanian)"
        },
        {
            "id": 137,
            "name": "Monacan"
        },
        {
            "id": 138,
            "name": "Mongolian"
        },
        {
            "id": 139,
            "name": "Montenegrin"
        },
        {
            "id": 140,
            "name": "Montserrat(British)"
        },
        {
            "id": 141,
            "name": "Moroccan"
        },
        {
            "id": 115,
            "name": "Mosotho"
        },
        {
            "id": 142,
            "name": "Mozambican"
        },
        {
            "id": 144,
            "name": "Namibian"
        },
        {
            "id": 145,
            "name": "Nauruan"
        },
        {
            "id": 146,
            "name": "Nepalese"
        },
        {
            "id": 148,
            "name": "New Caledonian"
        },
        {
            "id": 149,
            "name": "New Zealand"
        },
        {
            "id": 150,
            "name": "Nicaraguan"
        },
        {
            "id": 152,
            "name": "Nigerian"
        },
        {
            "id": 151,
            "name": "Nigerien"
        },
        {
            "id": 153,
            "name": "Niuean"
        },
        {
            "id": 154,
            "name": "North Korean"
        },
        {
            "id": 155,
            "name": "Northern Mariana Islander"
        },
        {
            "id": 156,
            "name": "Norwegian"
        },
        {
            "id": 157,
            "name": "Omani"
        },
        {
            "id": 158,
            "name": "Pakistani"
        },
        {
            "id": 159,
            "name": "Palauan"
        },
        {
            "id": 160,
            "name": "Palestine"
        },
        {
            "id": 161,
            "name": "Panamanian"
        },
        {
            "id": 91,
            "name": "Papal Pontifical"
        },
        {
            "id": 163,
            "name": "Paraguayan"
        },
        {
            "id": 164,
            "name": "Peruvian"
        },
        {
            "id": 165,
            "name": "Philippine"
        },
        {
            "id": 166,
            "name": "Polish"
        },
        {
            "id": 74,
            "name": "Polynesian"
        },
        {
            "id": 167,
            "name": "Portuguese"
        },
        {
            "id": 168,
            "name": "Puerto Rican"
        },
        {
            "id": 169,
            "name": "Qatari"
        },
        {
            "id": 170,
            "name": "Réunionian"
        },
        {
            "id": 174,
            "name": "Roman"
        },
        {
            "id": 171,
            "name": "Romanian"
        },
        {
            "id": 172,
            "name": "Russian"
        },
        {
            "id": 173,
            "name": "Rwandan"
        },
        {
            "id": 230,
            "name": "Sahrawi"
        },
        {
            "id": 63,
            "name": "Salvadorean"
        },
        {
            "id": 179,
            "name": "Samoan"
        },
        {
            "id": 4,
            "name": "Samoan"
        },
        {
            "id": 182,
            "name": "Saudi Arabian"
        },
        {
            "id": 183,
            "name": "Senegalese"
        },
        {
            "id": 184,
            "name": "Serb or Serbian"
        },
        {
            "id": 186,
            "name": "Sierra Leonian"
        },
        {
            "id": 187,
            "name": "Singaporean"
        },
        {
            "id": 191,
            "name": "Slomoni"
        },
        {
            "id": 189,
            "name": "Slovak"
        },
        {
            "id": 190,
            "name": "Slovenian"
        },
        {
            "id": 192,
            "name": "Somali"
        },
        {
            "id": 193,
            "name": "South African"
        },
        {
            "id": 194,
            "name": "South Korean"
        },
        {
            "id": 195,
            "name": "South Sudanese"
        },
        {
            "id": 196,
            "name": "Spanish"
        },
        {
            "id": 197,
            "name": "Sri Lankan"
        },
        {
            "id": 198,
            "name": "Sudanese"
        },
        {
            "id": 199,
            "name": "Surinamese"
        },
        {
            "id": 200,
            "name": "Swazi"
        },
        {
            "id": 201,
            "name": "Swedish"
        },
        {
            "id": 202,
            "name": "Swiss"
        },
        {
            "id": 203,
            "name": "Syrian"
        },
        {
            "id": 204,
            "name": "Taiwanese"
        },
        {
            "id": 205,
            "name": "Tajik"
        },
        {
            "id": 206,
            "name": "Tanzanian"
        },
        {
            "id": 207,
            "name": "Thai"
        },
        {
            "id": 209,
            "name": "Togolese"
        },
        {
            "id": 211,
            "name": "Tongan"
        },
        {
            "id": 212,
            "name": "Trinidadian"
        },
        {
            "id": 213,
            "name": "Tunisian"
        },
        {
            "id": 214,
            "name": "Turkish"
        },
        {
            "id": 215,
            "name": "Turkoman"
        },
        {
            "id": 217,
            "name": "Tuvaluan"
        },
        {
            "id": 218,
            "name": "Ugandan"
        },
        {
            "id": 219,
            "name": "Ukrainian"
        },
        {
            "id": 224,
            "name": "Uruguayan"
        },
        {
            "id": 225,
            "name": "Uzbek"
        },
        {
            "id": 226,
            "name": "Vanuatuan"
        },
        {
            "id": 227,
            "name": "Venezuelan"
        },
        {
            "id": 228,
            "name": "Vietnamese"
        },
        {
            "id": 229,
            "name": "Wallisian; Futunan"
        },
        {
            "id": 231,
            "name": "Yemeni"
        },
        {
            "id": 232,
            "name": "Zambian"
        },
        {
            "id": 233,
            "name": "Zimbabwean"
        }
    ],
    "board": [
        {
            "id": 1,
            "name": "Maharashtra State Board of Secondary and Higher Secondary Education, Pune"
        },
        {
            "id": 2,
            "name": "Central Board of Secondary Education, Delhi"
        },
        {
            "id": 3,
            "name": "Council for Indian School Certificate Examinations, New Delhi"
        },
        {
            "id": 4,
            "name": "International Baccalaureate"
        },
        {
            "id": 5,
            "name": "National Institute of Open Schooling (formarly National Open School), New Delhi"
        },
        {
            "id": 6,
            "name": "Andhra Pradesh Board of Intermediate Education, Hyderabad"
        },
        {
            "id": 7,
            "name": "Andhra Pradesh Board of Secondary Education, Hyderabad"
        },
        {
            "id": 8,
            "name": "Andhra Pradesh Open School Society, SCERT Campus, Hyderabad"
        },
        {
            "id": 9,
            "name": "Assam Higher Secondary Education Council, Bamunimaidan, Guwahati"
        },
        {
            "id": 10,
            "name": "Assam Board of Secondary Education, Guwahati"
        },
        {
            "id": 11,
            "name": "Asam Higher Secondary Education Council, Assam State Open School Bamunimaidan, Guwahati"
        },
        {
            "id": 12,
            "name": "Bihar Intermediate Education Council, Patna"
        },
        {
            "id": 13,
            "name": "Bihar School Examination Board, Patna"
        },
        {
            "id": 14,
            "name": "Bihar Sanskrit Shiksha Board, Patna"
        },
        {
            "id": 15,
            "name": "Bihar Board of Open Schooling & Examination, Patna"
        },
        {
            "id": 16,
            "name": "Chhatisgarh Board of Secondary Education, Raipur"
        },
        {
            "id": 17,
            "name": "Chhatisgarh Board of Secondary Education & State Open School, Raipur"
        },
        {
            "id": 18,
            "name": "Goa Board of Secondary & Higher Secondary Education, Goa"
        },
        {
            "id": 19,
            "name": "Gujarat Secondary & Higher Secondary Education Board, Gandhi Nagar"
        },
        {
            "id": 20,
            "name": "Gujarat State Open School, Gandhinagar Gujarat"
        },
        {
            "id": 21,
            "name": "Haryana Board of Education, Hansi Road, Bhiwani"
        },
        {
            "id": 22,
            "name": "Haryana Open School, Bhiwani"
        },
        {
            "id": 23,
            "name": "Himachal Pradesh Board of School Education, Dharamshala"
        },
        {
            "id": 24,
            "name": "Himachal Pradesh State Open School, Dharamsala, Kangra"
        },
        {
            "id": 25,
            "name": "J&K State Board of School Education, Jammu"
        },
        {
            "id": 26,
            "name": "J&K State Open School, Srinagar"
        },
        {
            "id": 27,
            "name": "Jharkhand Academic Council, Ranchi"
        },
        {
            "id": 28,
            "name": "Karnataka Board of the Pre-University Education, Bangalore"
        },
        {
            "id": 29,
            "name": "Karnataka Secondary Education Examination Borad, Bangalore"
        },
        {
            "id": 30,
            "name": "Karnataka Open School, J.S.S. Maha Vidya Peeth, Mysore"
        },
        {
            "id": 31,
            "name": "Kerala Board of Public Examinations, Pareeksha Bhawan, Thiruvananthpuram"
        },
        {
            "id": 32,
            "name": "Kerala Board of Higher Secondary Education, Thiruvananthapuram"
        },
        {
            "id": 33,
            "name": "Kerala State Open School, Thiruvananthapuram"
        },
        {
            "id": 34,
            "name": "Madhya Pradesh Board of Secondary Education, Bhopal"
        },
        {
            "id": 35,
            "name": "M.P. State Open School, Bhopal"
        },
        {
            "id": 36,
            "name": "Manipur Council of Higher Secondary Education, Imphal"
        },
        {
            "id": 37,
            "name": "Manipur Board of Secondary Education, Imphal"
        },
        {
            "id": 38,
            "name": "Meghalaya Board of School Education, Meghalaya"
        },
        {
            "id": 39,
            "name": "Mizoram Board of School Education Chaltlan, Aizawl"
        },
        {
            "id": 40,
            "name": "Nagaland Board of School Education, Kohima"
        },
        {
            "id": 41,
            "name": "Orissa Council of Higher Secondary Education Bhubaneswar"
        },
        {
            "id": 42,
            "name": "Orissa Board of Secondary Education, Cuttack"
        },
        {
            "id": 43,
            "name": "Punjab School Education Board, Mohali"
        },
        {
            "id": 44,
            "name": "Rajasthan Board of Secondary Education, Ajmer"
        },
        {
            "id": 45,
            "name": "Rajasthan State Open School, Jaipur"
        },
        {
            "id": 46,
            "name": "Tamil Nadu Board of Secondary Education, Chennai"
        },
        {
            "id": 47,
            "name": "Tamil Nadu Board of Higher Secondary Education, Chennai"
        },
        {
            "id": 48,
            "name": "Tamil Nadu State Open School, Chennai"
        },
        {
            "id": 49,
            "name": "Tripura Board of Secondary Education, Agartala, Tripura West"
        },
        {
            "id": 50,
            "name": "U.P. Board of High School & Intermediate Education, Allahabad"
        },
        {
            "id": 51,
            "name": "Uttranchal Shiksha Evm Pariksha Parishad, Ram Nagar, Nanital"
        },
        {
            "id": 52,
            "name": "West Bengal Board of Secondary Education, Calcutta"
        },
        {
            "id": 53,
            "name": "West Bengal Council of Higher Secondary Education, Calcutta"
        },
        {
            "id": 54,
            "name": "West Bengal Council for Rabindra Open Schooling"
        },
        {
            "id": 55,
            "name": "West Bengal Board of Madrasa Education"
        },
        {
            "id": 56,
            "name": "International General Certificate of Secondary Education"
        },
        {
            "id": 57,
            "name": "Board of Intermediate Education, Telangana"
        },
        {
            "id": 59,
            "name": "Maharashtra State Board of Technical Education(MSBTE), Mumbai"
        },
        {
            "id": 99,
            "name": "Any Other Board"
        }
    ]
}